import { createContext, FC, PropsWithChildren, useContext } from "react";

interface AuthLayoutContextValue {
    logo?: string;
}

const AuthLayoutContext = createContext<AuthLayoutContextValue>({});

export const AuthLayoutProvider: FC<PropsWithChildren<{ logo?: string }>> = ({ logo, children }) => (
    <AuthLayoutContext.Provider value={{ logo }}>{children}</AuthLayoutContext.Provider>
);

export const useAuthLayout = () => useContext(AuthLayoutContext);
